import { FACTIONS } from "@frontier/content/factions";
import type { PublicEventView } from "@frontier/content/events";

export function relayStatus(event: PublicEventView): string {
  if (event.status === "available") return `СИГНАЛ ЧЕРЕЗ ${Math.ceil(event.remaining)} С`;
  if (event.status === "failed") return "СИГНАЛ ПОТЕРЯН";
  const faction = event.capture?.factionId;
  if (event.status === "success") return faction ? `КОНТРОЛЬ: ${FACTIONS[faction].name}` : "ЗАХВАЧЕН";
  if (event.capture?.contested) return "ТОЧКА ОСПАРИВАЕТСЯ · ЗАХВАТ ОСТАНОВЛЕН";
  return faction ? `ЗАХВАТ: ${FACTIONS[faction].name}` : "ТОЧКА СВОБОДНА";
}
